import 'debug';
import { e as entryMixin, j as _typeof } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import { _ as __vue_normalize__ } from './normalize-component.js';

var script = {
  mixins: [entryMixin],
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {
    window.addEventListener('message', this.onMessage, false);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.onMessage, false);
  },
  methods: {
    onMessage: function onMessage(e) {
      var method = '';

      if (typeof e.data === 'string') {
        method = e.data;
      } else if (_typeof(e.data) === 'object') {
        method = e.data.method;
      } else {
        throw Error('event data must be a string or an object contains method property as string');
      }

      console.log('HtmlEntry.onMessage:', e.data, ', method', method);

      switch (method) {
        case 'touchstart':
          this.onTouchStart();
          break;

        case 'touchend':
          this.onTouchEnd();
          break;

        case 'back':
          this.$xp.history.back();
          break;

        case 'showPage':
          var path = '/page/' + e.data.pageID;
          this.$router.push(path);
          break;
      }
    },
    onTouchStart: function onTouchStart() {
      this.$xp.screen.postponeDim();
      var e = new Event('touchstart');
      window.dispatchEvent(e);
    },
    onTouchEnd: function onTouchEnd() {
      this.$xp.screen.postponeDim(2000);
      var e = new Event('touchend');
      window.dispatchEvent(e);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "js-entry o-entry c-html-entry" }, [
    _vm.entryData.Content.Index
      ? _c("iframe", {
          staticClass: "c-html-entry__iframe",
          attrs: {
            src:
              _vm.$xp.settings.baseUrl + "xpedeo/" + _vm.entryData.Content.Index
          }
        })
      : _vm.entryData.Content.Url
      ? _c("iframe", {
          staticClass: "c-html-entry__iframe",
          attrs: {
            src: _vm.$xp.settings.baseUrl + "pda/" + _vm.entryData.Content.Url
          }
        })
      : _vm._e()
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
